import React from 'react';
import { css } from '@emotion/core';

import { flexStart, SPACE_COZY, marginZero, breakWord } from '@/styles';
import { FCC } from '@/utils/types';

import { SkeletonHeader } from './skeleton';

interface IProps {
  title: string;
  description?: string;
  iconAfter?: React.ReactNode;
  isLoading?: boolean;
  isCompact?: boolean;
}

const PageHeader: FCC<IProps> = ({
  title,
  description,
  iconAfter,
  isLoading = false,
  isCompact = false,
  children,
  ...other
}) => (
  <div css={[flexStart]} {...other} className="PageHeader">
    <div
      css={css`
        width: 100%;
      `}
    >
      {!title || isLoading ? (
        <SkeletonHeader width={200} />
      ) : (
        <h1
          css={[
            marginZero,
            flexStart,
            isCompact
              ? css`
                  font-size: 24px;
                  font-weight: 500;
                `
              : '',
            breakWord,
          ]}
        >
          {title} {iconAfter}
        </h1>
      )}
      <p
        css={css`
          width: 80%;
          margin: ${SPACE_COZY}px 0;
          ${isCompact && !description?.length ? 'display: none;' : ''}
        `}
      >
        {!title || isLoading ? <SkeletonHeader width={300} /> : description}
      </p>
    </div>
    {children}
  </div>
);

export default PageHeader;
